const NotFound = () =>{
    return (
        <h1>404 NOT FOUND</h1>
    )
}

export default NotFound;